import { Api_routes, server_url } from '../config/API_Routes';
import { getRequest, patchRequest, postRequest, putRequest } from '../config/axios-config';

const createContract = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.contractsCreate,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const contractsList = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.contractsList,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const sendContract = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.sendContract,
        body
      );
      if (!response.status) {
        reject(new Error(response.data || 'Failed to send contract'));
      }
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      const errorMessage = err.response?.data || err.message || 'Failed to send contract';
      reject(new Error(errorMessage));
    }
  });
};

const getDataToFinalizeContract = ({ contractId, userId }) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.getDataToFinalizeContract +
          `/${userId}` +
          `/${contractId}`
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const finalizeContract = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.finalizeContract,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getAllFieldsForContract = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getAllFieldsForContract
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const customContractList = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.customContractList
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getContractTemplate = (templateId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getContractTemplate + `/${templateId}`
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const createContractTemplate = (file, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('data', JSON.stringify(data));

      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.createContractTemplate,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const updateCustomContract = (templateId, body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await putRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.updateCustomContract +
          `/${templateId}`,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const deleteCustomContract = (templateId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await patchRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.deleteCustomContract +
          `/${templateId}`
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

export {
  createContract,
  contractsList,
  sendContract,
  finalizeContract,
  getDataToFinalizeContract,
  getAllFieldsForContract,
  createContractTemplate,
  customContractList,
  updateCustomContract,
  deleteCustomContract,
  getContractTemplate,
};
